import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import { highlightColor } from './Ana';
import StepImage from '../../../images/features/ana/step_image.png';
import StepImage2 from '../../../images/features/ana/step_image2.png';
import Balloon from '../../../images/features/ana/balloon2.png';
import { makeTransformStyles } from '../../core/styles';

const useStyles = makeStyles((theme) => ({
  containerVerticalStep: {
    position: 'relative',
  },
  innerVerticalStep: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  triangle: {
    borderTop: '10px solid #90D2EF',
    borderRight: '10px solid transparent',
    borderLeft: '10px solid transparent',
  },
  title: {
    fontWeight: 'bold',
    color: 'white',
    display: 'inline-block',
    marginBottom: '0.5em',

    background: `linear-gradient(transparent 80%, ${highlightColor} 80%)`,
  },
  details: {
    fontWeight: 'bold',
    color: 'white',
    display: 'inline-block',
    textAlign: 'center',
  },
  stepImage: {
    width: 100,
    position: 'absolute',
    bottom: 0,
    right: 10,
  },
  balloon: {
    position: 'absolute',
    bottom: 0,
    left: -20,
    '& img': {
      width: '100%',
      maxWidth: 130,
      height: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      bottom: -11,
      left: -11,
      '& img': {
        ...makeTransformStyles('scale(1.2)'),
      },
    },
  },
}));

const Steps = ({ steps }) => {
  const classes = useStyles();
  return (
    <Grid container spacing={1}>
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <Grid item xs={12}>
            <Paper
              square
              style={{
                backgroundColor: step.color,
                height: step.className === 'sightseeing' ? 100 : 120,
              }}
              className={classes.containerVerticalStep}
            >
              <div className={classes.innerVerticalStep}>
                <span className={classes.title}>{step.title}</span>
                <span className={classes.details}>{step.details.join('')}</span>
              </div>
              {['sightseeing', 'sightseeing2'].includes(step.className) && (
                <div>
                  <img
                    src={
                      step.className === 'sightseeing' ? StepImage : StepImage2
                    }
                    alt="step_image"
                    className={classes.stepImage}
                  />
                  <div className={classes.balloon}>
                    <img src={Balloon} />
                  </div>
                </div>
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} container justify="center">
            {index !== steps.length - 1 && <div className={classes.triangle} />}
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default Steps;
